// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { NotificationsFollowedModel, UserNotificationPreferencesModel } from "@store/Framework/Types/ApiModels";
import { objectKeysToCamelCase } from "@store/Framework/Common/Utilities/objectKeyToCamelCase";
import { HasOnError } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface GetNotificationPreferencesParameter extends ApiParameter {
    hash: string;
}

export interface SendNotificationPreferencesParameter {
    hash: string;
    notificationsFollowed: {};
}

const baseUrl = "/api/v1/custom/user";

export async function getUserNotificationPreferences(
    parameter: GetNotificationPreferencesParameter & HasOnError,
): Promise<UserNotificationPreferencesModel> {
    try {
        const notifications = await get<UserNotificationPreferencesModel>(
            `${baseUrl}/notificationPreferences/${parameter.hash}`,
        );

        return objectKeysToCamelCase(notifications) as UserNotificationPreferencesModel;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            parameter.onError?.(error.errorJson.message);
        }

        throw error;
    }
}

export async function sendUserNotificationPreferences(
    parameter: SendNotificationPreferencesParameter & HasOnError,
): Promise<UserNotificationPreferencesModel> {
    const _parameter = {
        ...parameter,
        // Api expects PascalCase
        NotificationsFollowed: parameter.notificationsFollowed,
        Hash: parameter.hash,
    };

    try {
        const response = await post<NotificationsFollowedModel>(
            `${baseUrl}/notificationPreferences/${_parameter.Hash}`,
            _parameter.NotificationsFollowed as NotificationsFollowedModel,
        );

        return objectKeysToCamelCase(response) as UserNotificationPreferencesModel;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            parameter.onError?.(error.errorJson.message);
        }

        throw error;
    }
}
